import React from "react";

const MainPopup = ({
  children,
  popUpOpen,
  setpopUpOpen,
  forgetPopup,
  QRPopup,
  loginPopups,
  notificationPopups,
  bgcolor = false,
  widthAdjustment=false
}) => {
  const handleClose = () => {
    setpopUpOpen(false);
  };
  
  const handlePopupClick = (e) => {
    e.stopPropagation();
  };
  
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center overflow-y-auto z-[999] ${popUpOpen ? "block" : "hidden"} pointer-events-auto bg-[#00000080]`}
      onClick={handleClose}
    >
      <div
        className={`${
          loginPopups
            ? `m-auto ${widthAdjustment?" md:w-2/3 lg:w-2/3 ":" md:w-2/3 lg:w-1/2 mx-3"}w-full  relative overflow-hidden`
            : notificationPopups
            ? "lg:w-11/12 lg:mr-10 lg:my-16 m-auto w-full md:mx-auto md:my-auto"
            : forgetPopup
            ? "lg:mr-96 md:mx-auto lg:mx-96"
            : "relative lg:w-9/12 lg:mr-20 lg:my-16 m-auto w-10/12 md:mx-auto md:my-auto"
        }`}
        onClick={handlePopupClick}
      >
        <div
          className={`relative ${bgcolor ? 'bg-[#062B37]' :'bg-white' } rounded-lg shadow-2xl shadow-gray-400`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainPopup;